/* src/app/shared/components/layout/navbar/navbar.component.scss */
:host {
  display: block;
  width: 100%;
}
/*# sourceMappingURL=navbar.component.css.map */
